import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { Link } from '@liveauctioneers/hammer-ui-core/link';
import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { isTermsOfServiceUnknown, isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { submitConsent } from '@/redux/modules/consent/consent.actions';
import { getBidderConsentSubmitted } from '@/redux/modules/consent/consent.selectors';
import { getIsWhiteLabel } from '@/redux/modules/whiteLabel';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export const TermsOfServiceBanner = () => {
    const dispatch = useAppDispatch();
    const formatMessage = useAppFormatMessage();
    const { pathname } = useLocation();
    const userLoggedIn = useAppSelector(isUserLoggedIn);
    const isWhiteLabel = useAppSelector(getIsWhiteLabel);
    const checkout = pathname.includes('/console/');
    const biddingConsole = pathname.includes('/console/');
    const bidderConsentSubmitted = useAppSelector(getBidderConsentSubmitted);
    const termsOfServiceUnknown = useAppSelector(isTermsOfServiceUnknown);
    const submit = useCallback(() => {
        dispatch(
            submitConsent({
                consent: true,
                context: 'TermsOfServiceBanner',
            })
        );
    }, [dispatch]);

    const tosLink = (
        <Link
            href="/termsandconditions"
            key="terms-banner-tos"
            rel="noopener"
            target="_blank"
        >
            {formatMessage(['terms_and_conditions'])}
        </Link>
    );
    const privacyLink = (
        <Link
            href="/privacy"
            key="terms-banner-privacy"
            rel="noopener"
            target="_blank"
        >
            {formatMessage(['privacy_policy'])}
        </Link>
    );
    const cookieLink = (
        <Link
            href="/cookie-policy"
            key="terms-banner-cookie"
            rel="noopener"
            target="_blank"
        >
            {formatMessage(['cookie_policy'])}
        </Link>
    );

    const showTOSBanner = userLoggedIn && termsOfServiceUnknown && !isWhiteLabel && !checkout && !biddingConsole;

    return showTOSBanner ? (
        <div className="min-[374px]:text-[12px] flex bg-border-secondary px-[20px] py-xs text-[10px] xsMax:text-sm">
            <div className="min-[1241px]:mx-auto min-[1241px]:max-w-[860px] min-[1241px]:py-0 min-[1241px]:pr-0 min-[1241px]:pl-[20px] flex flex-auto justify-between xsMax:[&>*]:pr-[2em] [&>a:hover]:text-text-primary [&>a:hover]:underline [&>span]:text-text-inactive">
                <div className="mr-[1em] mt-0 xsMax:mt-[12px]">
                    {formatMessage(['terms_banner'], { values: { cookieLink, privacyLink, tosLink } })}
                </div>
                <div>
                    <Button
                        className="mt-0"
                        loading={bidderConsentSubmitted}
                        onClick={submit}
                        style={!isWhiteLabel ? 'critical' : 'primary'}
                    >
                        {formatMessage(['consent', 'agree'])}
                    </Button>
                </div>
            </div>
        </div>
    ) : null;
};
